<p align="center" class="initial-p">Cuidar da sua saúde é fundamental, agende um atendimento com o Posso Agendar :)</p>

<div class="container-responsive">
  <div class="toolbar-wrapper">
    <mat-toolbar color="primary" (click)="goToUrl('/patient-new/agendar/especialistas/exame')">
      <mat-toolbar-row><mat-icon>monitor_heart</mat-icon></mat-toolbar-row>
      <mat-toolbar-row>Agendar</mat-toolbar-row>
    </mat-toolbar>
  </div>
</div>
